$(function () {
	$('.p-voice-guide__audio').each(function () {
		var audio = $(this).find("audio").get(0);
		var isPlaying = false;
		$(this).find(".start-btn").on("click", function () {
			if (isPlaying) {
				audio.pause();
			} else {
				audio.play();
			}
		});
		audio.onplaying = function () {
			isPlaying = true;
		};
		audio.onpause = function () {
			isPlaying = false;
		};
	});
});
